export interface ThemeData {
  variables: string;
  assetsPath: string;
  brandName: string;
  productName: string;
  abaName: string;
  abcName: string;
  atiName: string;
  backupVendor: string;
  limitedUse?: boolean;
  useTelemetry: boolean;
}

const config: Record<typeof APP_THEME, ThemeData> = {
  acronis: {
    variables: 'src/assets/styles/themes/default',
    assetsPath: '/src/assets/images/acronis',
    brandName: 'Acronis',
    productName: 'Acronis Cyber Frame',
    abaName: 'Acronis Cyber Protect',
    abcName: 'Acronis Cyber Protect Cloud',
    atiName: 'Acronis True Image',
    backupVendor: 'Acronis',
    limitedUse: false,
    useTelemetry: false
  },
  virtuozzo: {
    variables: 'src/assets/styles/themes/default',
    assetsPath: '/src/assets/images/virtuozzo',
    brandName: 'Virtuozzo',
    productName: 'Virtuozzo Infrastructure',
    abaName: 'Acronis Cyber Protect',
    abcName: 'Acronis Cyber Protect Cloud',
    atiName: 'Acronis True Image',
    backupVendor: 'Acronis',
    useTelemetry: true
  },
  'vz-converted': {
    variables: 'src/assets/styles/themes/default',
    assetsPath: '/src/assets/images/acronis',
    brandName: 'Acronis',
    productName: 'Acronis Cyber Frame',
    abaName: 'Acronis Cyber Protect',
    abcName: 'Acronis Cyber Protect Cloud',
    atiName: 'Acronis True Image',
    backupVendor: 'Acronis',
    useTelemetry: false
  }
};

export default config;
